import React, { useContext } from 'react';
import { TagContext } from '../../../../context/TagContext';
import { DeleteTagResponse, DeleteTagVariables, TagMutations } from '../../../../graphql/tag.graphql';
import useMutation from '../../../../hooks/useMutation';
import { useToast } from '../../../../providers/ToastProvider';
import { Tag, TagInput } from '../../../../types/tag';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Button, ButtonVariant, CancelButton } from '../../../components/Button';
import { AlertModal } from '../../../components/Modal';
import { ToastType } from '../../../components/Toast';

interface DeleteTagModalProps {
  tag: Tag;
  open: boolean;
  setOpen: (open: boolean) => void;
}
export default function DeleteTagModal({ tag, open, setOpen }: DeleteTagModalProps) {
  const { showToast } = useToast();

  const { tags, setTags } = useContext(TagContext);

  const [remove, { loading }] = useMutation<DeleteTagResponse, DeleteTagVariables>(TagMutations.remove, {
    variables: { tags: [new TagInput(tag).forDelete()] },
    onCompleted: response => {
      tags.delete(response.deleteTag[0].id);
      setTags(new Map(tags));
      showToast({ type: ToastType.success, title: t(TranslationKey.tagDeletedSuccessfullyToastTitle).singular.upper });
      setOpen(false);
    },
  });

  return (
    <AlertModal title={t(TranslationKey.deleteTagModalTitle).singular.upper} open={open} setOpen={setOpen}>
      <div className='grid gap-4'>
        <p className='subtitle'>{t(TranslationKey.deleteTagModalSubtitle).singular.upper}</p>
        <div className='flex justify-end gap-2'>
          <CancelButton onClick={() => setOpen(false)} disabled={loading} />
          <Button
            variant={ButtonVariant.danger}
            text={t(TranslationKey.deleteTag).singular.upper}
            onClick={() => remove()}
            loading={loading}
          />
        </div>
      </div>
    </AlertModal>
  );
}
